import type { GetNativeReportParams } from '@/repository/native-reports';
import type {
  FilterValuesParams,
  ReportWindowParams,
} from '@/repository/custom-reports';
import type { GetReportParams } from '@/repository/reports';
import type { ListSavedReportsParams } from '@/repository/saved-reports';
import type { ReportSpecRead } from '@/types/generated/endpoints/custom_reports';

export const REPORTS_QUERY_KEYS = {
  reportBase: ['reports', 'report'] as const,
  report: (params: GetReportParams) => ['reports', 'report', params] as const,
} as const;

export const CUSTOM_REPORTS_QUERY_KEYS = {
  registry: (reportWindow: ReportWindowParams) =>
    ['reports', 'custom', 'registry', reportWindow] as const,
  filterValues: (params: FilterValuesParams | null) =>
    ['reports', 'custom', 'filter-values', params] as const,
  runBase: ['reports', 'custom', 'run'] as const,
  run: (spec: ReportSpecRead | null) =>
    ['reports', 'custom', 'run', spec] as const,
} as const;

export const NATIVE_REPORTS_QUERY_KEYS = {
  base: ['reports', 'native'] as const,
  googleOffered: ['reports', 'native', 'google-offered'] as const,
  report: (params: GetNativeReportParams | null) =>
    ['reports', 'native', params] as const,
} as const;

export const PLATFORM_LINKS_QUERY_KEYS = {
  list: ['reports', 'platform-links'] as const,
} as const;

export const SAVED_REPORTS_QUERY_KEYS = {
  listBase: ['reports', 'saved', 'list'] as const,
  list: (params: ListSavedReportsParams) =>
    ['reports', 'saved', 'list', params] as const,
} as const;
